import React, { FC } from "react";
import { Link } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";
import Prices from "./Prices";
import { Product, PRODUCTS } from "data/data";
import ModalQuickView from "./ModalQuickView";
import ProductStatus from "./ProductStatus";

export interface ProductCardProps {
  className?: string;
  data?: Product;
  isLiked?: boolean;
}

const ProductCard: FC<ProductCardProps> = ({
  className = "",
  data = PRODUCTS[0],
}) => {
  const {
    name,
    productType,
    vendorCode,
    brand,
    price,
    description,
    status,
    image,
    link
  } = data;
  const [showModalQuickView, setShowModalQuickView] = React.useState(false);

  return (
    <>
      <div
        className={`nc-ProductCard relative flex flex-col bg-transparent ${className}`}
        data-nc-id="ProductCard"
      >
        <Link to={link} target="_blank" className="absolute inset-0"></Link>

        <div className="relative flex-shrink-0 bg-slate-50 dark:bg-slate-300 rounded-3xl overflow-hidden z-1 group">
          <Link to={link} target="_blank" className="block">
            <NcImage
              containerClassName="flex aspect-w-11 aspect-h-12 w-full h-0"
              src={image}
              className="object-contain w-full h-full"
              style={{mixBlendMode: 'multiply'}}
              loading="lazy"
            />
          </Link>

          <ProductStatus status={status} />
        </div>

        <div className="px-[0.3rem] mt-[1.45rem] pb-2.5">

            <h2
              className={`nc-ProductCard__title text-[12px] lg:text-[14px] text-[#7e838d] transition-colors uppercase leading-[18px] lg:leading-[20px]`}
            >
              {
                productType && vendorCode && brand ?
                    <>
                    <span className="text-[#7e838d] font-story inline-block">{productType}</span> <br/>
                    <span className="text-[#050505] font-kozukaR inline-block">{brand}</span>&nbsp;
                    <span className="text-[#050505] font-yuGothicUi">{vendorCode}</span>
                    </>
                    : name
              }
            </h2>
            <p className={`text-sm text-slate-500 dark:text-slate-400 mt-1 `}>
              {description}
            </p>

          <div className="mt-2.5 flex items-start">
            <Prices price={price} className="text-sm font-regular" contentClass="py-1 md:py-1.5 text-sm font-regular" />
          </div>
        </div>
      </div>

      {/* QUICKVIEW */}
      <ModalQuickView
        show={showModalQuickView}
        onCloseModalQuickView={() => setShowModalQuickView(false)}
      />
    </>
  );
};

export default ProductCard;
